import { AriaRole, useId } from "react";
import cx from "classnames";

import useTypedContext from "hooks/useTypedContext";
import { ThemeContext } from "views/Theme";
import { BoxProps } from "ds/components/Box";

import styles from "./styles.module.css";
import CardWrapper from "../../components/Wrapper";
import { CardCollapsibleContext } from "./Context";

type CardCollapsibleWrapperProps = {
  variant?: "secondary" | "primary";
  withTransition?: boolean;
  role?: AriaRole;
  ref?: React.ForwardedRef<HTMLDivElement>;
  isCollapsed: boolean;
  onToggle: () => void;
} & Pick<BoxProps, "children" | "className">;

const CardCollapsibleWrapper = ({
  children,
  variant,
  isCollapsed,
  onToggle,
  role,
  className,
  ref,
}: CardCollapsibleWrapperProps) => {
  const contentId = useId();

  const { reducedMotion } = useTypedContext(ThemeContext);

  return (
    <CardCollapsibleContext.Provider value={{ isCollapsed, onToggle, contentId }}>
      <CardWrapper
        direction="column"
        fullWidth
        variant={variant}
        role={role}
        className={cx(styles.collapsibleWrapper, className, {
          [styles.withTransition]: !reducedMotion,
          [styles.isCollapsed]: isCollapsed,
        })}
        ref={ref}
      >
        {children}
      </CardWrapper>
    </CardCollapsibleContext.Provider>
  );
};

CardCollapsibleWrapper.displayName = "DS.Card.Collapsible.Wrapper";

export default CardCollapsibleWrapper;
